import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import getStaticFile from '../../utils/getStaticFile';
import styles from './RegenerativeMedicine.module.scss';
import classNames from 'classnames';
import { Button } from '@src/components/ui';
import { Link } from 'react-router-dom';
import { useCart } from '../../hooks/useCart';
// import productHomepageData from '../../data/products/homepage'; // Removed: file deprecated and not a module
import Toast from '../../components/Toast';
import { formatCurrency } from '../../utils/formatters';
import { getProducts } from '../../api/ProductApi';
import { requestError } from '../../utils/request';
const RegenerativeMedicine = () => {
    const [toastMessage, setToastMessage] = useState('');
    const [isToastVisible, setIsToastVisible] = useState(false);
    const [btiProducts, setBtiProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { addItem, isLoading: cartLoading } = useCart();
    useEffect(() => {
        loadProducts();
    }, []);
    const loadProducts = async () => {
        try {
            setLoading(true);
            setError(null);
            // Load only BTI products
            const btiResponse = await getProducts({ manufacturer: 'BTI', is_available: true, category: "Regenerative Medicine" });
            setBtiProducts(btiResponse.body);
        }
        catch (err) {
            console.error('Error loading products:', err);
            setError('Failed to load products. Please try again.');
            requestError(err, 'Failed to load products');
        }
        finally {
            setLoading(false);
        }
    };
    const handleAddToCart = async (product) => {
        if (cartLoading)
            return;
        try {
            await addItem({
                id: product.id.toString(),
                name: product.title,
                sku: product.sku,
                price: parseFloat(product.price),
                image: product.imageUrlDisplay || '',
                quantity: 1,
                notDiscountable: product.notDiscountable,
            });
            setToastMessage(`${product.title} added to cart`);
            setIsToastVisible(true);
        }
        catch (err) {
            console.error('Failed to add item to cart:', err);
            setToastMessage('Failed to add item to cart');
            setIsToastVisible(true);
        }
    };
    const renderProductTiles = (products, sectionTitle) => (_jsxs("section", { className: styles.productTiles, children: [_jsx("div", { className: styles.sectionHeader, children: _jsx("h2", { children: sectionTitle }) }), _jsx("div", { className: styles.tilesContainer, children: products.length === 0 ? (_jsx("div", { className: styles.noProducts, children: _jsxs("p", { children: ["No ", sectionTitle, " products available at the moment."] }) })) : (products.map((product) => (_jsxs("div", { className: styles.productTile, children: [_jsxs(Link, { to: `/products/${product.path}`, children: [product.imageUrlDisplay && (_jsx("img", { src: product.imageUrlDisplay, alt: product.title })), _jsx("h3", { children: product.title }), _jsx("div", { className: styles.price, children: _jsx("span", { children: formatCurrency(product.displayPrice || product.price) }) }), _jsx("p", { children: product.description }), !product.isAvailable && (_jsx("div", { className: styles.unavailableBadge, children: "Out of Stock" }))] }), _jsx("div", { className: styles.buttonWrapper, children: _jsx(Button, { variant: "primary", label: cartLoading
                                    ? 'Adding...'
                                    : product.stockQuantity > 0
                                        ? 'Add to Cart'
                                        : 'Out of Stock', onClick: () => handleAddToCart(product), disabled: !product.isAvailable || product.stockQuantity === 0 || cartLoading }) })] }, product.id)))) })] }));
    if (loading) {
        return (_jsx("main", { className: styles.regenerativeMedicine, children: _jsx("div", { className: styles.loadingContainer, children: _jsx("p", { children: "Loading products..." }) }) }));
    }
    if (error) {
        return (_jsx("main", { className: styles.regenerativeMedicine, children: _jsxs("div", { className: styles.errorContainer, children: [_jsx("p", { children: error }), _jsx(Button, { variant: "primary", label: "Retry", onClick: loadProducts })] }) }));
    }
    return (_jsxs("main", { className: styles.regenerativeMedicine, children: [_jsx(Toast, { message: toastMessage, isVisible: isToastVisible, onClose: () => setIsToastVisible(false) }), _jsxs("section", { className: styles.hero, children: [_jsx("img", { src: getStaticFile('assets/regen_med_page_banner.png'), alt: "Regenerative Medicine", className: styles.heroImage }), _jsx("div", { className: styles.heroContent, children: _jsxs("div", { children: [_jsx("h1", { className: classNames({ [styles.noWrap]: false }), children: "Regenerative Medicine" }), _jsx("p", { children: "Advanced regenerative medicine solutions for faster healing and improved patient outcomes." })] }) })] }), _jsx("section", { className: styles.blueSection, children: _jsxs("div", { className: styles.blueContent, children: [_jsx("div", { children: _jsx("h2", { children: "About Regenerative Medicine" }) }), _jsx("div", { children: _jsx("p", { children: "Our advanced PRGF therapy system provides cutting-edge solutions for orthopedic, wound healing, and pain management applications." }) })] }) }), renderProductTiles(btiProducts, '')] }));
};
export default RegenerativeMedicine;
